/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Segment } from '../../models/segment';
import { SegmentResponse } from '../../models/segment-response';

export interface CreateSegment$Params {
  'Active-Tenant-Identifier': string;
      body: Segment
}

export function createSegment(http: HttpClient, rootUrl: string, params: CreateSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<SegmentResponse>> {
  const rb = new RequestBuilder(rootUrl, createSegment.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SegmentResponse>;
    })
  );
}

createSegment.PATH = '/segments';
